import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatRegular from './chat-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatRegular {...props} />;
}
SvgComponent.iconName = 'chatRegular';

export const ChatRegularIcon = svgIconWrapper(SvgComponent);
